import { useAuthorization } from 'src/hooks/use-authorization';

export const useAiAgentsAccess = () => {
  const { getFeatureFlag, hasPermission } = useAuthorization();
  const isEnabled = getFeatureFlag('ai_agents');

  return {
    canViewAiAgents: isEnabled && hasPermission('ai:company.ai_agent:access'),
    canViewAiKnowledgeBases:
      isEnabled && hasPermission('ai:company.ai_agent_knowledge_base:access'),
  };
};
